import { queryOptions, useQueryClient } from '@tanstack/vue-query';
import type { OrganisationKind } from '@cutr/constants/organisations';
import { getOrganisationKind } from '@/api/organisationKinds';
import { organisationKindKeys } from './keys';
import { ORGANISATION_KIND_STALE_TIME_MS } from './shared/staleTimes';
import { queryClient } from './queryClient';
import { customerOrganisationDetailOptions } from './customerOrganisations';
import { partnerOrganisationDetailOptions } from './partnerOrganisations';

export function organisationKindOptions(organisationId: string) {
  return queryOptions({
    queryKey: organisationKindKeys.detail(organisationId),
    queryFn: ({ signal }) => getOrganisationKind(organisationId, signal),
    staleTime: ORGANISATION_KIND_STALE_TIME_MS,
  });
}

/** For links that predate the kind in the organisation URL: the router resolves it before redirecting. */
export function resolveOrganisationKind(organisationId: string) {
  return queryClient.fetchQuery(organisationKindOptions(organisationId));
}

/** For a caller that already knows the kind and reads one organisation on demand, outside the organisation page. */
export function useFetchOrganisationDetail() {
  const queryClient = useQueryClient();

  return (kind: OrganisationKind, organisationId: string) =>
    kind === 'customer'
      ? queryClient.fetchQuery(
          customerOrganisationDetailOptions(organisationId)
        )
      : queryClient.fetchQuery(
          partnerOrganisationDetailOptions(organisationId)
        );
}
